import {Component, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {OrganisationService} from "../../services/organisation/organisation.service";
import {PermissionsService} from "../../services/permissions/permissions.service";
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';

@Component({
  selector: 'app-teams-add-edit',
  templateUrl: './teams-add-edit.component.pug',
  styleUrls: ['./teams-add-edit.component.scss'],
  standalone: false
})
export class TeamsAddEditComponent {
  @Output() closeEvent = new EventEmitter<string>();

  // pug file label text
  heading = '';
  subHeading = '';
  saveButtonText = '';
  placeholderText = $localize `Enter team name`;

  // data variables
  teamName = '';
  savedTeamName = '';
  teamId = 0;
  turnOffLoader = true;
  isValid = true;
  errors = [
    {name: 'sameName', msg: $localize`A team with this name already exists, please try another.`, enabled: false},
    {name: 'validName', msg: $localize`Please enter a team name`, enabled: false},
  ];
  popupType = 'add-team';

  @ViewChild('inputElement', { read: ElementRef }) inputElement!: ElementRef;

  constructor(
    public modalRef: BsModalRef,
    public organisationService: OrganisationService,
    private permissions: PermissionsService,
    private alertList: AlertBannerService
  ) {
  }

  ngOnInit(): void {
    this.savedTeamName = this.teamName;
    this.errors = [...this.errors, {name: 'tooLong', msg: $localize`This field accepts a maximum of 200 characters.`, enabled: false}];
    if (this.popupType === 'add-team'){
      this.heading = $localize`Add team`;
      this.subHeading = $localize`Add a new team.`;
      this.saveButtonText = $localize`Add team`;
    }
    else if(this.popupType === 'edit-team'){
      this.heading = $localize`Edit team`;
      this.subHeading = $localize`Edit the team name.`;
      this.saveButtonText = $localize`Save`;
    }
  }

  setError(name: string, enabled: boolean) {
    this.errors.find(o => o.name === name)!.enabled = enabled;
    this.errors = [...this.errors];
    this.isValid = this.errors[0].enabled || this.errors[1].enabled;

  }
  resetErrors(){
    this.isValid = false;
    this.errors.forEach(x => x.enabled = false)
  }

  textValueChanged(event: any) {
    this.isValid = false;
    if(this.errors.some(x => x.enabled)){
      this.resetErrors();
      setTimeout(() => {
        this.inputElement?.nativeElement?.childNodes[0]?.focus();
      }, 0);
    }

  }

  saveButtonClicked(){
    this.resetErrors()

    if(this.teamName === ''){
      this.setError('validName', true);
    } else if (this.teamName.length > 200) {
      this.setError('tooLong', true);
    }
    // else if(this.teamName === 'Default Team'){
    //   this.setError('sameName', true);
    // }
    else{
      this.turnOffLoader = false;
      if (this.popupType === 'add-team') {
        this.organisationService.createTeam({name: this.teamName.trim()}).subscribe({
          next: response => {
            this.turnOffLoader = true;
            this.closeEvent.emit('team-added');
            this.modalRef?.hide();
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! ${this.teamName} has been saved.`,
              keepOnRouteChange: true
            }]);
          },
          error: response => {
            this.savedTeamName = this.teamName;
            if (response.error.message == "Team already exists") {
              this.setError('sameName', true)
            } else if (response.error.message == "Team name too long") {
              this.setError('tooLong', true)
            }
            this.turnOffLoader = true;
          },    // errorHandler
          complete: () => {
          }, // completeHandler
        });
      }
      else if (this.popupType === 'edit-team') {
        this.organisationService.updateTeam({id: this.teamId, name: this.teamName.trim()}).subscribe({
          next: response => {
            this.turnOffLoader = true;
            this.closeEvent.emit('team-updated');
            this.modalRef?.hide();
          },
          error: response => {
            this.savedTeamName = this.teamName;
            if (response.error.message == "Team already exists") {
              this.setError('sameName', true)
            } else if (response.error.message == "Team name too long") {
              this.setError('tooLong', true)
            }
            this.turnOffLoader = true;
          },    // errorHandler
          complete: () => {
          }, // completeHandler
        });
      }
    }
  }

}
